export const pageMonCompteAbonnementsProps = () => ({
  abonnements: {
    type: Array,
    required: true
  }
})

export const usePageMonCompteAbonnements = (props) => {
  const abonnementsEnCours = computed(() => {
    return props.abonnements.filter(abonnement => abonnement.attributes.en_cours)
  })
  const abonnementsTermine = computed(() => {
    return props.abonnements.filter(abonnement => !abonnement.attributes.en_cours)
  })

  return {
    abonnementsEnCours,
    abonnementsTermine
  }
}